import { render, staticRenderFns } from "./ProductCogs.vue?vue&type=template&id=8cd0973e"
import script from "./ProductCogs.vue?vue&type=script&lang=js"
export * from "./ProductCogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports